export default "__VITE_ASSET__D3G6Zggu__"